import { css } from '@emotion/react'

export const Loader = () => (
  <div
    data-testid="table-loader-animation-img"
    css={css`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;

      color: #26b999;
      font-size: 10px;
      text-indent: -9999em;
      transform: translateZ(0);
      animation-delay: -0.16s;
      border-radius: 50%;
      width: 2.5em;
      height: 2.5em;
      animation-fill-mode: both;
      animation: load7 1.8s infinite ease-in-out;

      &:before,
      &:after {
        border-radius: 50%;
        width: 2.5em;
        height: 2.5em;
        animation-fill-mode: both;
        animation: load7 1.8s infinite ease-in-out;
      }

      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 0;
      }

      &:before {
        left: -3.5em;
        animation-delay: -0.32s;
      }
      &:after {
        left: 3.5em;
      }

      @-webkit-keyframes load7 {
        0%,
        80%,
        100% {
          box-shadow: 0 2.5em 0 -1.3em;
        }
        40% {
          box-shadow: 0 2.5em 0 0;
        }
      }

      @keyframes load7 {
        0%,
        80%,
        100% {
          box-shadow: 0 2.5em 0 -1.3em;
        }
        40% {
          box-shadow: 0 2.5em 0 0;
        }
      }
    `}>
    Loader...
  </div>
)
